import backendConfig from "../config/backendConfig.ts";

export interface ProductReview {
  id: string;
  name: string;
  rating: number;
  comment: string;
  createdAt: string;
}

export interface ReviewSummary {
  average: number;
  count: number;
  reviews: ProductReview[];
}

const mapSummary = (data: any): ReviewSummary => ({
  average: Number(data?.average) || 0,
  count: Number(data?.count) || 0,
  reviews: (data?.reviews || []).map((review: any) => ({
    id: review._id,
    name: review.name,
    rating: review.rating,
    comment: review.comment,
    createdAt: review.createdAt,
  })),
});

export const getProductReviews = async (
  productId: string,
): Promise<ReviewSummary> => {
  const response = await fetch(
    `${backendConfig.API_BASE_URL}${backendConfig.ENDPOINTS.REVIEWS}/product/${productId}`,
  );
  const result = await response.json();
  if (!response.ok || !result.success) {
    throw new Error(result.error || "Could not load reviews.");
  }
  return mapSummary(result.data);
};

export const createReview = async (
  productId: string,
  review: { name: string; rating: number; comment: string },
): Promise<ReviewSummary> => {
  const response = await fetch(
    `${backendConfig.API_BASE_URL}${backendConfig.ENDPOINTS.REVIEWS}/product/${productId}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(review),
    },
  );
  const result = await response.json();
  if (!response.ok || !result.success) {
    throw new Error(result.error || "Could not post your review.");
  }
  return mapSummary(result.data);
};
